import React from 'react';
import { Form } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import {
  firstError, firstResponseError, pruneServerErrors, checkMaxLength, validationClasses,
} from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetAttachmentEditDialog = ({ theme }) => {
  const state = Selectors.useDatasetAttachmentEditDialog();
  const updateProperties = Events.useUpdateDatasetAttachmentProperties();
  const hide = Events.useHideEditDatasetAttachmentDialog();
  const postData = Events.useUpdateDatasetAttachmentDescription(state);
  const description = state.attachment.metadata.description || '';

  const checkForErrors = (value) => {
    const updateErrors = [];
    const title = 'dataset.attachment.description.error';

    checkMaxLength(value, [fields.DESCRIPTION], updateErrors, 'attachment', title, globalFieldLengths.description);

    updateProperties({ properties: { updateErrors } });
    return updateErrors;
  };

  const submitForm = () => {
    const errors = checkForErrors(description);

    if (errors.length === 0) {
      postData(state);
    }
  };

  const descriptionError = state.updateErrors.find((e) => (e.fields.includes(fields.DESCRIPTION)));

  return (
    <Dialog
      className="aridhia-dataset-attachment-editing-dialog"
      error={firstResponseError(state.updateErrors)}
      icon="edit"
      inProgress={state.updateStatus === states.PENDING}
      minimumDataEntryMet={state.isDirty}
      onClose={hide}
      onDismiss={() => updateProperties({ properties: { updateErrors: pruneServerErrors(state.updateErrors) } })}
      onSave={submitForm}
      saveMessageId="actions.modify"
      theme={theme}
      title={state.attachment.name}
    >
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(state.updateErrors) !== null}>
        <FormValidationError error={descriptionError} labelId="save.dataset.attachment.description">
          <MarkdownEditor
            autoFocus
            className={validationClasses(descriptionError)}
            disabled={state.updateStatus === states.PENDING}
            id="attachment_description"
            maxEditorHeight={80}
            minPreviewHeight={94}
            onChange={(value) => updateProperties({ properties: { attachment: { metadata: { description: value } } } })}
            value={description}
          />
        </FormValidationError>
      </Form>
    </Dialog>
  );
};

export default DatasetAttachmentEditDialog;
